export default "__VITE_ASSET__B5GXkU5g__"